import slice from './slice.template';
import * as templateTypes from './types.template';

export const { reducer: templateState, actions: templateActions } = slice;
export { templateTypes };
export { default as templateSaga } from './saga.template';
export { default as templateSelector } from './selector.template';
export default slice;
